module.exports = __webpack_public_path__ + "img/2@2x.f1957b69.png";